export default __webpack_public_path__ + "8e6a9a9f98e34f84b669923f767ed361.svg";